var render = function render(){var _vm=this,_c=_vm._self._c;return _c('photos',{key:_vm.config.storeField,attrs:{"config":_vm.config}})
}
var staticRenderFns = []

export { render, staticRenderFns }